/**
 * 表示の書式（画面仕様書 §2.2）。
 * 時間は「8時間30分」、時刻は「08:30」（跨日は「25:30」）で統一する。
 */

import {
  currentMonthInJst,
  formatDuration,
  formatTime,
  todayInJst,
  weekdayLabel,
} from '@meisui/core';

export { formatDuration, formatTime, weekdayLabel };

/** 未入力の時刻は「—」で表す */
export function formatTimeOrDash(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : formatTime(value);
}

/** 2026-06-01 → 6月1日（月） */
export function formatDateLabel(date: string): string {
  const [, month, day] = date.split('-');
  return `${Number(month)}月${Number(day)}日（${weekdayLabel(date)}）`;
}

/** 2026-06 → 2026年6月 */
export function formatMonthLabel(month: string): string {
  const [year, m] = month.split('-');
  return `${year}年${Number(m)}月`;
}

/** ISO 日時 → 6月1日 18:20（端末の設定によらず日本時間で表示する） */
export function formatDateTime(iso: string | null): string {
  if (!iso) return '—';
  const date = new Date(new Date(iso).getTime() + 9 * 60 * 60 * 1000);
  return `${date.getUTCMonth() + 1}月${date.getUTCDate()}日 ${String(date.getUTCHours()).padStart(
    2,
    '0',
  )}:${String(date.getUTCMinutes()).padStart(2, '0')}`;
}

export function formatYen(value: number): string {
  return `${value.toLocaleString('ja-JP')}円`;
}

/** 前月比などの増減 */
export function formatDelta(value: number, unit = ''): string {
  if (value === 0) return `増減なし`;
  return `${value > 0 ? '+' : '−'}${Math.abs(value)}${unit}`;
}

/** YYYY-MM に月を加算する */
export function shiftMonth(month: string, delta: number): string {
  const [year, m] = month.split('-').map(Number);
  const date = new Date(Date.UTC(year ?? 2026, (m ?? 1) - 1 + delta, 1));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
}

/** 「今日」は端末の時計ではなく日本時間で決める（海外や時計ずれでも同じ日付になるように） */
export function todayIso(): string {
  return todayInJst();
}

export function currentMonth(): string {
  return currentMonthInJst();
}
